export const ACCESS_TYPE = 'sse'; // ws or sse 标志链接方式
// export const APP_KEY = 'AIEZQwNYOsXRGmuSVBnYHSqmIbJfHhmQGDrOTWLIaZnxymixMnzitHEVwHuSqelNXdOlzTmBOVNtMdXwvcvReUzJOKBQwrhOjZFslgnwCVWSMmuEESKdLNYLipALZJgL'; // 体验机器人的appkey
export const APP_KEY = process.env.APP_KEY; // 体验机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js